
import { useEffect, useState } from "react";
import { inject, observer } from 'mobx-react';
import { DashbaordService, CommonService } from "../../services";
import { Card, Button, FormLoading, Select, ModalAlert } from '../../components'
import {
  Chart,
  Series,
  ArgumentAxis,
  CommonSeriesSettings,
  Export,
  Legend,
  ValueAxis,
  Point,
  Tooltip
} from 'devextreme-react/chart';
import PieChart, {
  Legend as PLegend,
  Series as PSeries,
  Tooltip as PTooltip,
  Title,
  Label,
  Font,
  Connector,
} from 'devextreme-react/pie-chart';
import { DatePicker, Button as ButtonAntd } from 'antd';
import { UserIcon, SearchIcon } from "@heroicons/react/solid";
import dayjs from 'dayjs';
import moment from 'moment'
import { isEmpty } from "lodash";
import StackedBar from "./Charts/StackedBar";
import LineChart from "./Charts/LineChart";
import { useTranslation } from 'react-i18next'
// import { SearchOutlined } from '@ant-design/icons';

// import {   } from 'ant-design/icons';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD', monthFormat = 'MM/YYYY';
let intervalUpdate: any = null
let filterCurrents: any = {}
let timeoutOnKey: any = null, firstRender = false
declare const Highcharts: any;
export const CardNumber = (props) => {
  const { t } = useTranslation(['dashboard'])
  return <div className="divide-y divide-primary-500 rounded-lg bg-primary-500 border border-primary-500">
    <div className="px-4 py-1 dark:bg-gray-800 text-center bg-primary-500 rounded-t-lg">
      <h3 className="text-white" style={{ fontSize: 25 }}>{t(props.title)}</h3>
    </div>
    <div className="relative bg-white rounded-b-lg h-20 flex items-center px-4">
      <div className="mx-auto">
        <span className="font-semibold text-primary-500" style={{ fontSize: 50 }}>
          {props.value}
        </span>
      </div>
      {props.percen && (
        <div className="absolute right-4">
          <span className="text-red-500 text-2xl font-semibold">{props.jobPercen}</span>
        </div>
      )}
    </div>
  </div>
}

export const CardStat = (props) => {
  const { t } = useTranslation(['dashboard'])
  return <div className="bg-white rounded-lg shadow-md p-2 w-full max-w-md">
    <h4 className="text-xl font-semibold text-gray-800 mb-4 text-center">
      {t(props.title)}
    </h4>

    <div className="grid grid-cols-3 gap-4 items-center">
      <div className="flex justify-center items-center">
        <div className="text-primary-500">
          {/* <UserIcon className="w-10 h-10 text-yellow-500" /> */}
          {props?.prefixIcon}
        </div>
      </div>

      <div className="flex justify-center items-center">
        <span className={`text-4xl font-medium ${props?.lbCenter.color}`}>
          {props?.lbCenter.value}
        </span>
      </div>

      <div className="flex flex-col items-center">
        {/* <span className={`text-sm`} style={{ color: props?.direction === "up" ? "green" : "red" }}>15%</span> */}
        {props?.suffixIcon}
      </div>
    </div>
  </div>
}

let WORDING = {
  "success": "จัดส่งสำเร็จ",
  "in_progress": "ระหว่างการจัดส่ง",
  "failed": "จัดส่งไม่สำเร็จ",
  "in_queue": "งานรอคิว"
}
const Dashboard = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['dashboard', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const VIEWTYPE = [
    {
      value: 1,
      label: t('date_range')
    },
    {
      value: 2,
      label: t('month_year')
    },
    {
      value: 3,
      label: t('year')
    }
  ]
  const [loading, setLoading] = useState(false)
  const [masterOptions, setMasterOptions] = useState({
    customer: [],
    product: []
  })

  const [filter, setFilter]: any = useState({
    sdate: moment().format("YYYY-MM-DD"),
    edate: moment().format("YYYY-MM-DD"),
    view_type: 1,
    year: moment().format("YYYY"),
    month: moment().format("MM"),
    cust_list: [],
    product_list: []
  })
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: []
    }
  })
  const [dataDash, setDataDash]: any = useState(DEFAULT_DATA)
  const [jobData, setJobData]: any = useState([])
  const [chartVisibled, setChartVisibled]: any = useState('stack') // line, stack

  const customizePoint = (point) => {
    switch (point.argument) {
      case "จัดส่งสำเร็จ":
        return { color: "#7ed957" };

      case "ระหว่างการจัดส่ง":
        return { color: "#ffde59" };

      case "จัดส่งไม่สำเร็จ":
        return { color: "#f44d1c" };

      case "งานรอคิว":
        return { color: "#ab9b90" };

      default:
        return {};
    }
  };

  const customizeTooltip = (arg) => {
    const key: any = Object.keys(WORDING).find(
      (k) => WORDING[k] === arg.argumentText
    )
    return {
      text: `${t(key)} : ${arg.value}`,
    };
  }

  const customizeText = (arg) => {
    const key: any = Object.keys(WORDING).find(
      (k) => WORDING[k] === arg.pointName
    )
    return t(key);
  }


  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "customer,product")
        .then((res: any) => {
          let customer = res.result.customer.map((item) => ({ label: item.cust_name, value: item.cust_id }))
          let product = res.result.product.map((item) => ({ label: item.product_name, value: `${item.product_id}` }))
          setMasterOptions({
            ...masterOptions,
            customer,
            product

          })
        })
        .catch((err) => {

        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  useEffect(() => {
    setupMap(DEFAULT_DATA.maps)
    setTimeout(() => {
      getDash()
    }, 500);
  }, [])


  const getDash = (isReloadCurrent = false) => {
    clearTimeout(intervalUpdate)
    if (!isReloadCurrent) setLoading(true)

    let filterData: any = {
      view_type: filter.view_type
    }

    if (isReloadCurrent) {
      filterData = isReloadCurrent ? filterCurrents : filter
    }
    else {
      if (filter.view_type === 1) {
        filterData.sdate = filter.sdate
        filterData.edate = filter.edate
      }
      else if (filter.view_type === 2) {
        filterData.month = filter.month
        filterData.year = filter.year
      }
      else if (filter.view_type === 3) {
        filterData.year = filter.year
      }
      filterCurrents = filterData
    }


    if (filter.cust_list.length > 0) {
      let cust_list = filter.cust_list.join(",")
      filterData.cust_list = cust_list
    }
    if (filter.product_list.length > 0) {
      let product_list = filter.product_list.join(",")
      filterData.product_list = product_list
    }

    DashbaordService.getDashboard(auth, filterData)
      .then((res: any) => {
        let { code, message, result, sys_message } = res
        if (code === 200) {
          if (!isEmpty(result)) {
            let pieChart = [
              {
                region: 'จัดส่งสำเร็จ',
                field: "job_success",
                val: result?.job_success
              },
              {
                region: 'ระหว่างการจัดส่ง',
                field: "job_assign",
                val: result?.job_assign
              },
              {
                region: 'จัดส่งไม่สำเร็จ',
                field: "job_fail",
                val: result?.job_fail
              },
              {
                region: 'งานรอคิว',
                field: "job_unassign",
                val: result?.job_unassign
              }
            ]
            result.pieChart = pieChart

            // let split_job_dlv_avg_cmp = result.job_dlv_avg_cmp.split(' ')
            setDataDash(result)
            setupMap(result.maps)
          }
        }
        else {
          setDataDash(DEFAULT_DATA)
          setupMap(DEFAULT_DATA.maps)
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        if (!isReloadCurrent) {
          setTimeout(() => setLoading(false), 500);
        }
      })
      .catch((err) => {
        setDataDash(DEFAULT_DATA)
        setupMap(DEFAULT_DATA.maps)
        if (!isReloadCurrent) {
          setTimeout(() => setLoading(false), 500);
        }
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }

  const setupMap = (data) => {
    (async () => {
      try {
        const topology = await fetch(
          'https://code.highcharts.com/mapdata/countries/th/th-all.topo.json'
        ).then(response => response.json());

        // Prepare demo data. The data is joined to map using value of 'hc-key'
        // property by default. See API docs for 'joinBy' for more info on linking
        // data and map.

        // Create the chart
        if (typeof Highcharts !== 'undefined') {
          Highcharts.mapChart('container-highcharts', {
            chart: {
              map: topology
            },
            title: {
              text: '' //'แผนที่การจัดส่ง'
            },
            mapNavigation: {
              enabled: true,
              buttonOptions: {
                verticalAlign: 'bottom'
              }
            },

            colorAxis: {
              min: 0, stops: [
                [0, '#e6f4e6'], // light green
                [0.5, '#66cc66'], // medium green
                [1, '#006600'] // dark green
              ]
            },

            series: [{
              data,
              name: 'Random data',
              states: {
                hover: {
                  color: '#BADA55'
                }
              },
              dataLabels: {
                enabled: true,
                format: '{point.name}'
              }
            }]
          });
        }
      } catch (error) {

      }
    })();
  }

  let dateRange: any = [dayjs(filter.sdate, dateFormat), dayjs(filter.edate, dateFormat)]
  return <div className="space-y-3">
    <FormLoading loading={loading}>
      <div>
        <div className="flex flex-col md:flex-row bg-white p-4 md:p-2 items-start md:items-center">
          {/* Logo */}
          {/* <div className="flex-shrink-0 mb-4 md:mb-0">
            <img className="h-20 w-auto" src="/icons/qlog-logo.png" alt="logo" />
          </div> */}

          {/* Filters กลาง */}
          <div className="flex-1 flex justify-center">
            <div className="flex flex-wrap items-end gap-2">
              {/* ลูกค้า */}
              <div className="flex flex-row space-x-2">
                <label className="text-xs font-medium text-gray-700 mt-3">{t('customer')}</label>
                <Select
                  hiddenLabel={true}
                  multiple={true}
                  defaultValue={filter.cust_list}
                  width={200}
                  placeholder={t('customer')}
                  options={masterOptions.customer}
                  onChange={(value) => setFilter({ ...filter, cust_list: value })}
                />
              </div>

              {/* สินค้า */}
              <div className="flex flex-row space-x-2">
                <label className="text-xs font-medium text-gray-700 mt-3">{t('product')}</label>
                <Select
                  hiddenLabel={true}
                  multiple={true}
                  defaultValue={filter.product_list}
                  width={200}
                  placeholder={t('product')}
                  options={masterOptions.product}
                  onChange={(value) => setFilter({ ...filter, product_list: value })}
                />
              </div>

              {/* รูปแบบ */}
              <div className="flex flex-row space-x-2">
                <label className="text-xs font-medium text-gray-700 mt-3">{t('type')}</label>
                <Select
                  hiddenLabel={true}
                  defaultValue={filter.view_type}
                  width={200}
                  placeholder={t('type')}
                  options={VIEWTYPE}
                  onChange={(value) => setFilter({ ...filter, view_type: value })}
                />
              </div>

              {
                filter.view_type === 1 && <RangePicker
                  allowClear={false}
                  defaultValue={dateRange}
                  style={{ marginTop: 4 }}
                  onChange={(d: any) => {
                    if (d) {
                      setFilter({
                        ...filter,
                        sdate: d[0].format("YYYY-MM-DD"),
                        edate: d[1].format("YYYY-MM-DD")
                      })
                    }
                    else {
                      setFilter({
                        ...filter,
                        sdate: "",
                        edate: ""
                      })
                    }
                  }}
                />
              }

              {
                filter.view_type === 2 && <DatePicker
                  allowClear={false}
                  defaultValue={dayjs(`${filter.month}/${filter.year}`, monthFormat)}
                  style={{ marginTop: 4 }}
                  format={monthFormat}
                  onChange={(date, dateString: any) => {
                    let spDate = dateString.split('/')
                    setFilter({
                      ...filter,
                      month: spDate[0],
                      year: spDate[1]
                    })
                  }}
                  picker="month" />
              }

              {
                filter.view_type === 3 && <DatePicker
                  defaultValue={dayjs(filter.year, "YYYY")}
                  onChange={(date, dateString) => setFilter({ ...filter, year: dateString })}
                  style={{ marginTop: 4 }}
                  picker="year" />
              }


              {/* ปุ่มค้นหา */}
              <div className="mt-2 md:mt-0">
                <Button
                  iconOnly={<SearchIcon />}
                  iconPosition="start"
                  onClick={() => getDash()}
                />
              </div>
            </div>
          </div>

          {/* User / Company */}
          {/* <div className="flex-shrink-0 flex flex-col items-center mt-4 md:mt-0 md:ml-4">
            <UserIcon className="w-10 h-10 text-yellow-500" />
            <span className="text-xs mt-1 text-center">บริษัท ความซื่อตรงแล้วรวย</span>
          </div> */}
        </div>


        <div className="p-3">
          <div className="p-4 space-y-4">
            {/* Top summary row */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {/* <div className="bg-white rounded-md p-2">CONTENT</div> */}
              <CardNumber title="number_of_trips" value={dataDash.total_route} />
              <CardNumber title="number_of_delivery_points" value={dataDash.total_qno} />
              <CardNumber title="average_tasks_per_day" value={dataDash.avg_route} />
              <CardNumber title="return_delivery" value={dataDash.job_ret_back} percen={true} jobPercen={dataDash.job_ret_back_cmp} />
            </div>

            {/* Middle big chart + two small cards */}
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
              {/* <div className="lg:col-span-2">
              <div className="bg-white rounded-lg shadow-md p-6 w-full mx-auto">
                <div>
                  XXX
                </div>
                <h4 className="font-semibold text-gray-800 mb-4 text-center" style={{ fontSize: 25 }}>
                  ประเภทการจัดสินค้า
                </h4>
                <div className="text-gray-600 text-base text-center">
                  <StackedBar />
                </div>
              </div>
            </div> */}

              <div className="lg:col-span-2">
                <div className="bg-white rounded-lg shadow-md p-6 w-full mx-auto">
                  <div className="flex justify-between items-center mb-4">
                    <div className="text-left space-x-2">
                      <ButtonAntd
                        type={chartVisibled === 'stack' ? 'primary' : 'default'}
                        style={{ backgroundColor: chartVisibled === 'stack' ? '#a72b20' : '#FFF' }}
                        icon={<i className="fa fa-bar-chart" />} size="small"
                        onClick={() => setChartVisibled('stack')}
                      />
                      <ButtonAntd
                        type={chartVisibled === 'line' ? 'primary' : 'default'}
                        style={{ backgroundColor: chartVisibled === 'line' ? '#a72b20' : '#FFF' }}
                        icon={<i className="fa fa-line-chart" />} size="small"
                        onClick={() => setChartVisibled('line')}
                      />
                    </div>
                    <h4 className="font-semibold text-gray-800 mx-auto text-center" style={{ fontSize: 25 }}>
                      {t('delivery_type')}
                    </h4>
                  </div>
                  <div className="text-gray-600 text-base text-center">
                    {
                      chartVisibled === 'stack' ? <StackedBar dataSource={dataDash?.jobs} /> : <LineChart dataSource={dataDash?.jobs} />
                    }
                  </div>
                </div>
              </div>


              <div className="bg-white rounded-md shadow-md p-6 w-full mx-auto p-2">
                <h4 className="font-semibold text-gray-800 mb-4 text-center" style={{ fontSize: 25 }}>
                  {t('delivery_status')}
                </h4>
                <div className="text-gray-600 text-base text-center">
                  <PieChart
                    id="pie"
                    type="doughnut"
                    palette="Soft Pastel"
                    innerRadius={0.6}
                    animation={false}
                    resolveLabelOverlapping="shift"
                    // dataSource={dataDash.pieChart}
                    dataSource={
                      dataDash.pieChart.every(item => item.val === 0)
                        ? dataDash.pieChart
                        : dataDash.pieChart.filter(item => item.val > 0)
                    }
                    customizePoint={(e) => customizePoint(e)}
                  >
                    <Title text="">
                      <Font size={18} weight={500} family="IBM Plex Sans Thai" />
                    </Title>
                    <PSeries argumentField="region">
                      <Label
                        visible={true}
                        position={"inside"}
                      >
                        <Connector visible={true} />
                        <Font size={14} weight={900} />
                      </Label>
                    </PSeries>
                    <Export enabled={false} />
                    <PLegend
                      visible={false}
                      margin={8}
                      verticalAlignment="Button"
                      horizontalAlignment="center"
                      itemTextPosition="right"
                      customizeText={(e) => customizeText(e)}
                    >
                      <Font size={12} weight={500} family="IBM Plex Sans Thai" />
                    </PLegend>
                    <PTooltip
                      enabled={true}
                      customizeTooltip={(e) => customizeTooltip(e)}
                    >
                    </PTooltip>
                  </PieChart>

                  <div className="flex flex-wrap justify-center gap-4 mt-4">
                    {dataDash.pieChart.map((item) => (
                      <div
                        key={item.field}
                        className="flex items-center gap-2 text-[12px]"
                      >
                        <span
                          className="w-3 h-3"
                          style={{
                            backgroundColor: customizePoint({
                              argument: item.region,
                            })?.color,
                          }}
                        />
                        <span style={{ fontSize: 12 }}>
                          {customizeText({ pointName: item.region })}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-md shadow-md p-6 w-full mx-auto">
                <h4 className="font-semibold text-gray-800 mb-4 text-center" style={{ fontSize: 25 }}>
                  {t('delivery_area')}
                </h4>
                <div className="text-gray-600 text-base text-center">
                  <div id="container-highcharts"></div>
                </div>
              </div>
            </div>

            {/* Bottom metrics row */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">

              <CardStat
                title="on_time_delivery"
                prefixIcon={<img className="h-20 w-auto" src="/icons/dashboard/icon-1.png" alt="logo" />}
                lbCenter={{
                  value: <div className="flex flex-row">
                    {dataDash.job_dlv_actual}
                    <div className="flex flex-col items-center ml-2">
                      <span className={`text-sm`} style={{ color: "green" }}>
                        {dataDash.job_dlv_actual_cmp}
                      </span>
                      <TriangleSVG direction="up" fill="green" />
                    </div>
                  </div>,
                  color: "text-green-600"
                }}
                suffixIcon={
                  <div>
                    <span className="text-gray-500">
                      {dataDash.job_dlv_actual_job} งาน
                    </span>
                  </div>
                }
              />
              <CardStat
                title="average_delivery_time_per_task"
                prefixIcon={<img className="h-20 w-auto" src="/icons/dashboard/icon-2.png" alt="logo" />}
                lbCenter={{
                  value: dataDash.job_dlv_avg,
                  color: "text-blue-600"
                }}
                suffixIcon={
                  <div>
                    <div className="flex flex-col items-center ml-2">
                      <span className={`text-sm`} style={{ color: "green" }}>
                        {dataDash.job_dlv_avg_cmp}
                      </span>
                      <TriangleSVG direction="up" fill="green" />
                    </div>
                  </div>
                }
              />
              {/* <CardStat
                title="average_delivery_time_per_task"
                prefixIcon={<img className="h-20 w-auto" src="/icons/dashboard/icon-3.png" alt="logo" />}
                lbCenter={{
                  value: dataDash.job_dlv_cost,
                  color: "text-gray-600"
                }}
                suffixIcon={
                  <div>
                    <div className="flex flex-col items-center ml-2">
                      <span className={`text-sm`} style={{ color: "green" }}>
                        {dataDash.job_dlv_cost_cmp}
                      </span>
                      <TriangleSVG direction="up" fill="green" />
                    </div>
                  </div>
                }
              /> */}

              <div className="bg-white rounded-lg shadow-md w-full max-w-md mx-auto relative pb-6">
                <div className="px-6">
                  <div className="grid grid-cols-3 items-center mb-4">
                    <h2 className="text-md font-semibold text-gray-800">{t('revenue_today')}</h2>
                    <div className="flex justify-center">
                      <img className="h-20 w-auto" src="/icons/dashboard/icon-4.png" alt="logo" />
                    </div>
                    <h2 className="text-sm font-semibold flex justify-end text-gray-800">{t('accumulated_revenue_monthly')}</h2>
                  </div>
                </div>

                <div className="grid grid-cols-2 absolute bottom-6 left-6 right-6">
                  <div className="flex flex-col justify-end text-left text-gray-600">
                    <div className="flex flex-row">
                      <span>฿{dataDash.job_rev_today}</span>
                      <TriangleSVG direction="down" fill="red" />
                    </div>
                  </div>

                  <div className="flex flex-col items-end text-right text-gray-600 ml-2">
                    <span className="text-sm" style={{ color: "green" }}>
                      {dataDash.job_rev_total_cmp}
                    </span>
                    <TriangleSVG direction="up" fill="green" />
                    <span>฿{dataDash.job_rev_total}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <ModalAlert
        {...optionAlert}
        onOk={() => {
          setOptionAlert({ ...optionAlert, show: false })
        }}
        onCancel={() => {
          setOptionAlert({ ...optionAlert, show: false })
        }}
      />
    </FormLoading>
  </div >
}))

export default Dashboard


const TriangleSVG = (props: any) => {
  let { direction, fill } = props

  if (direction === "up") {
    return (
      <svg width="18" height="15.59" viewBox="0 0 18 15.59" xmlns="http://www.w3.org/2000/svg">
        <polygon points="9,0 18,15.59 0,15.59" fill={fill} />
      </svg>

    );
  }
  else {
    return (
      <svg width="18" height="15.59" viewBox="0 0 18 15.59" xmlns="http://www.w3.org/2000/svg">
        <polygon points="0,0 18,0 9,15.59" fill={fill} />
      </svg>
    );
  }
};

// pieChart: [
//   {
//     region: 'ระหว่างจัดส่ง',
//     field: "job_assign",
//     val: 0,
//   },
//   {
//     region: 'จัดส่งสำเร็จ',
//     field: "job_success",
//     val: 0,
//   },
//   {
//     region: 'จัดส่งไม่สำเร็จ',
//     field: "job_fail",
//     val: 0,
//   }


const DEFAULT_DATA = {
  "total_route": 0,
  "total_qno": 0,
  "total_service": 0,
  "avg_route": 0,
  "job_unassign": 0,
  "job_assign": 0,
  "job_success": 0,
  "job_fail": 0,
  "job_ret_back": 0,
  "job_ret_back_cmp": "0 %",
  "job_dlv_actual": "0 %",
  "job_dlv_actual_job": "0",
  "job_dlv_actual_cmp": "0 %",
  "job_dlv_avg": "0 นาที",
  "job_dlv_avg_cmp": "0 %",
  "job_dlv_cost": "0 Baht",
  "job_dlv_cost_cmp": "0 %",
  "job_rev_today": "0",
  "job_rev_total": "0",
  "job_rev_total_cmp": "0 %",
  "sdate": "",
  "edate": "",
  "view_type": "1",
  "jobs": [],
  "pieChart": [
    {
      region: 'ระหว่างจัดส่ง',
      field: "job_assign",
      val: 0,
    },
    {
      region: 'จัดส่งสำเร็จ',
      field: "job_success",
      val: 0,
    },
    {
      region: 'จัดส่งไม่สำเร็จ',
      field: "job_fail",
      val: 0,
    },
    {
      region: 'งานรอคิว',
      field: "job_unassign",
      val: 0,
    }
  ],
  "maps": [
    ["th-ct", null],
    ["th-4255", null],
    ["th-pg", null],
    ["th-st", null],
    ["th-kr", null],
    ["th-sa", null],
    ["th-tg", null],
    ["th-tt", null],
    ["th-pl", null],
    ["th-ps", null],
    ["th-kp", null],
    ["th-pc", null],
    ["th-sh", null],
    ["th-at", null],
    ["th-lb", null],
    ["th-pa", null],
    ["th-np", null],
    ["th-sb", null],
    ["th-cn", null],
    ["th-bm", null],
    ["th-pt", null],
    ["th-no", null],
    ["th-sp", null],
    ["th-ss", null],
    ["th-sm", null],
    ["th-pe", null],
    ["th-cc", null],
    ["th-nn", null],
    ["th-cb", null],
    ["th-br", null],
    ["th-kk", null],
    ["th-ph", null],
    ["th-kl", null],
    ["th-sr", null],
    ["th-nr", null],
    ["th-si", null],
    ["th-re", null],
    ["th-le", null],
    ["th-nk", null],
    ["th-ac", null],
    ["th-md", null],
    ["th-sn", null],
    ["th-nw", null],
    ["th-pi", null],
    ["th-rn", null],
    ["th-nt", null],
    ["th-sg", null],
    ["th-pr", null],
    ["th-py", null],
    ["th-so", null],
    ["th-ud", null],
    ["th-kn", null],
    ["th-tk", null],
    ["th-ut", null],
    ["th-ns", null],
    ["th-pk", null],
    ["th-ur", null],
    ["th-sk", null],
    ["th-ry", null],
    ["th-cy", null],
    ["th-su", null],
    ["th-nf", null],
    ["th-bk", null],
    ["th-mh", null],
    ["th-pu", null],
    ["th-cp", null],
    ["th-yl", null],
    ["th-cr", null],
    ["th-cm", null],
    ["th-ln", null],
    ["th-na", null],
    ["th-lg", null],
    ["th-pb", null],
    ["th-rt", null],
    ["th-ys", null],
    ["th-ms", null],
    ["th-un", null],
    ["th-nb", null]
  ]
}

const JOB_DATA = [
  {
    "series_name": "01/06/25",
    "total_job": 1,
    "ขนส่งแบบเที่ยว-นำกลับ (ไม่คิดเงิน)": 1
  },
  {
    "series_name": "05/06/25",
    "total_job": 1,
    "ขนส่งแบบกล่อง-นำกลับ (ไม่คิดเงิน)": 1
  },
  {
    "series_name": "11/06/25",
    "total_job": 2,
    "ขนส่งแบบเที่ยว": 1,
    "ขนส่งแบบเที่ยว-นำกลับ (ไม่คิดเงิน)": 1
  },
  {
    "series_name": "12/06/25",
    "total_job": 0,
    "ขนส่งแบบเที่ยว": 0
  },
  {
    "series_name": "13/06/25",
    "total_job": 7,
    "ขนส่งแบบเที่ยว": 7
  },
  {
    "series_name": "17/06/25",
    "total_job": 1,
    "ลูกค้ามารับสินค้าเอง (ไม่คิดค่าบริการขนส่ง)": 1
  },
  {
    "series_name": "20/06/25",
    "total_job": 7,
    "ขนส่งแบบเที่ยว": 7
  },
  {
    "series_name": "23/06/25",
    "total_job": 8,
    "ขนส่งแบบเที่ยว": 7,
    "ขนส่งแบบเที่ยว-นำกลับ (ไม่คิดเงิน)": 1
  },
  {
    "series_name": "01/06/25",
    "total_job": 1,
    "ขนส่งแบบเที่ยว-นำกลับ (ไม่คิดเงิน)": 1
  },
  {
    "series_name": "05/06/25",
    "total_job": 1,
    "ขนส่งแบบกล่อง-นำกลับ (ไม่คิดเงิน)": 1
  },
  {
    "series_name": "11/06/25",
    "total_job": 2,
    "ขนส่งแบบเที่ยว": 1,
    "ขนส่งแบบเที่ยว-นำกลับ (ไม่คิดเงิน)": 1
  },
  {
    "series_name": "12/06/25",
    "total_job": 0,
    "ขนส่งแบบเที่ยว": 0
  },
  {
    "series_name": "13/06/25",
    "total_job": 7,
    "ขนส่งแบบเที่ยว": 7
  },
  {
    "series_name": "17/06/25",
    "total_job": 1,
    "ลูกค้ามารับสินค้าเอง (ไม่คิดค่าบริการขนส่ง)": 1
  },
  {
    "series_name": "20/06/25",
    "total_job": 7,
    "ขนส่งแบบเที่ยว": 7
  },
  {
    "series_name": "23/06/25",
    "total_job": 8,
    "ขนส่งแบบเที่ยว": 7,
    "ขนส่งแบบเที่ยว-นำกลับ (ไม่คิดเงิน)": 1
  }
]